import cls from "classnames";
import { forwardRef } from "react";
import PropTypes from "prop-types";
import Spinner from "@qoohoo/common/library/loader/Spinner";
import { PercentageIcon } from "./Icons";

const Input = forwardRef(
  (
    {
      value,
      onSubmit,
      onChange,
      className,
      isValidating,
      variant = Input.VARIANTS.underline,
      isLightTheme,
      applyTextColor,
      applyHoverTextColor,
    },
    ref
  ) => (
    <div
      className={cls(
        "flex items-center w-full relative text-sm p-3",
        { "border-b-2": variant === Input.VARIANTS.underline },
        isLightTheme ? "border-[rgba(255,255,255,.9)]" : "border-[#323941]",
        variant === "box" ? "pl-3" : "pl-0",
        className
      )}
      ref={ref}
    >
      <span
        className={cls("flex-shrink-0 mr-2 text-white", {
          "text-opacity-40": value.length === 0,
        })}
      >
        <PercentageIcon className="stroke-current dark:stroke-[#868686] h-4 w-4" />
      </span>

      <input
        className="bg-transparent flex-1 outline-none min-w-0"
        value={value}
        onChange={(e) => {
          onChange(e.target.value.toUpperCase().trim());
        }}
        onSubmit={onSubmit}
        onKeyPress={(e) => e.key === "Enter" && onSubmit(e)}
        placeholder="Discount Coupon"
      ></input>
      <button
        onClick={onSubmit}
        disabled={value.length === 0}
        className={cls(
          "flex-shrink-0 ml-2 relative",
          applyTextColor ? applyTextColor :
          isLightTheme ? "text-white" : "text-[#70C3FF] ",
          applyHoverTextColor ? applyHoverTextColor : isLightTheme ? "enabled:hover:text-[rgba(255,255,255,.9)] " : "enabled:hover:text-[#97d0f9] ",
          {
            "text-opacity-40 dark:text-opacity-100 font-semibold": value.length === 0,
          },
          {
            "font-bold": value.length !==0
          }
        )}
      >
        {isValidating ? <Spinner className="!h-3 !w-3" /> : "APPLY"}
      </button>
    </div>
  )
);

export default Input;

Input.VARIANTS={
  underline: "underline",
  box: "box"
}

Input.prototype = {
  value: PropTypes.string.isRequired,
  onSubmit: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  className: PropTypes.string,
  variant: PropTypes.oneOf[(Input.VARIANTS.underline, Input.VARIANTS.box)],
};
